import React, { useEffect, useRef, useState } from 'react';

export interface PortalTargetProps {
    name: string;
    className?: string;
}

export const PortalTarget = ({ name, className }: PortalTargetProps) => {
    const [ready, setReady] = useState(false);
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        setReady(true);
        // Dispatch the ready event in a microtask so the DOM has committed the
        // data-portal-ready attribute before any listener observes the event.
        // eslint-disable-next-line promise/catch-or-return
        Promise.resolve().then(() => {
            const el = ref.current;
            if (!el) {
                return;
            }
            const event = new CustomEvent(`${name}-target-ready`, { bubbles: true, detail: name });
            el.dispatchEvent(event);
        });
    }, [name]);

    return <div data-portal={name} data-portal-ready={ready ? '' : undefined} ref={ref} className={className} />;
};

export default PortalTarget;
